import React from 'react';
import PropTypes from 'prop-types';

export default class PageContent extends React.PureComponent {
  static propTypes = {
    entry: PropTypes.string.isRequired,
    data: PropTypes.array.isRequired,
    loading: PropTypes.bool,
    children: PropTypes.node,
  }

  state = {
    entry: this.props.entry,
    data: this.props.data,
    pageData: null,
  };

  componentDidMount() {
    // Process data when component mounts if available
    if (this.state.data && this.state.data.length > 0) {
      this.processPageData();
    }
  }

  componentDidUpdate(prevProps) {
    // Check if data prop has been updated
    if (prevProps.data !== this.props.data) {
      this.setState({ data: this.props.data }, () => {
        if (this.state.data && this.state.data.length > 0) {
          this.processPageData();
        }
      });
    }
  }

  processPageData() {
    const data = this.state.data;
    if (!data || data.length === 0) return;
    
    const page = data.filter(entry => entry.sys.id === this.state.entry);
    if (page && page.length > 0) {
      this.setState({ pageData: page[0].fields });
    }
  }

  render() {
    // Only try to render data if it's available
    const { pageData } = this.state;
    const { loading } = this.props;
    
    // Add loading state while waiting for data
    if (loading || !pageData) {
      return (
        <div className="content">
          <div className="content-inner">
            <p>Loading content...</p>
          </div>
        </div>
      );
    }
    
    return (
      <div className="content">
        <div className="content-inner">
          <div dangerouslySetInnerHTML={{ __html: pageData.content }} />
          {this.props.children}
        </div>
      </div>
    );
  }
}
